"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_1 = __importDefault(require("@honeybadger-io/js"));
const beforeNotifyHandler_1 = __importDefault(require("./beforeNotifyHandler"));
const honeybadgerCache_1 = __importDefault(require("./honeybadgerCache"));
/* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function  */
const noop = (..._args) => { };
const HoneybadgerStub = {
    context: {},
    beforeNotify: noop,
    configure: noop,
    errorHandler: noop,
    requestHandler: noop,
    lambdaHandler: noop,
    config: {},
    afterNotify: noop,
    setContext: (context) => {
        HoneybadgerStub.context = { ...HoneybadgerStub.context, ...context };
    },
    clear: noop,
    notify: (...args) => {
        console.log('Honeybadger JS is stubbed in this environment, skipping notice:', ...args);
    },
};
function createHoneybadger(config) {
    if (!config.apiKey)
        return HoneybadgerStub;
    if (honeybadgerCache_1.default.instance)
        throw Error('Honeybadger already exists');
    honeybadgerCache_1.default.instance = js_1.default.factory({ ...config, __plugins: js_1.default.config.__plugins });
    honeybadgerCache_1.default.instance.configure();
    honeybadgerCache_1.default.instance.beforeNotify(beforeNotifyHandler_1.default);
    honeybadgerCache_1.default.instance.__getAdditionalContext__ = config.getAdditionalContext;
    return honeybadgerCache_1.default.instance;
}
exports.default = createHoneybadger;
//# sourceMappingURL=createHoneybadger.js.map